<template>
  <div class="content">
     <headernav defaultActive="/buildings"/>
     <banner :img="backimg" title="新闻动态" />
    <div class="articledel_box">
      <div class="articledel_content">
       <div class="me_title">{{tempdata.post_title}}</div>
      <div class="englisthtext">Digital central kitchen</div>
      <div class="me_remarktext">{{tempdata.post_excerpt}}</div>
     <div v-html="tempdata.post_content"></div>
     </div>
         <el-divider content-position="left">往期文章</el-divider>
         <div class="article_bombox">
           <div class="articlebom_li" v-for="item in list" :key="item.id" @click="openarticledel(item.id)">
             <img :src="item.more.thumbnail" alt="">
             <div style="color:#999999;font-size:13px;margin-bottom:10px;">{{item.published_time}}</div>
             <div style="color:#333;font-size:17px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.post_title}}</div>
           </div>
         </div>
    </div>
     <botsolid/>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import Botsolid from "../components/botsolid";
import Headernav from "../components/headernav";
export default {
  data() {
    return {
      articleid:'',
      tempdata:{},
      parentid:'',
      list:[],
      backimg:''
    };
  },
  components: {
    Banner,
    Botsolid,
    Headernav
  },
   created(){
  window.console.log(this.$route.query.id)
  this.articleid = this.$route.query.id
  this.parentid = this.$route.query.parentid
  this.backimg = this.$route.query.backimg
  },
  mounted(){
  this.getarticledel()
  this.getparentlist()
  },
  methods:{
    openarticledel(id){
    this.articleid = id
    this.getarticledel()
    },
    getarticledel(){
       this.$http.get("/api/portal/julihe/read?id="+this.articleid,).then(response => {
          this.tempdata = response.data.data
      })
    },
    getparentlist(){
       this.$http.get("/api/portal/julihe/category_posts?limit=3&category_id="+this.parentid,).then(response => {
          this.list = response.data.data.list
      })
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-divider__text{
    font-size:20px;
    color:#333;
}
/deep/ .el-divider{
    background:#999;
}
/deep/ .el-divider--horizontal{
    margin:50px 0;
}
/deep/ .el-row{
  display: flex;
}
/deep/ .el-tabs__nav{
 float: right;
 width: 20.83333%;
}
/deep/ .el-tabs__nav-wrap::after{
  content:none;
}
/deep/ .el-tabs__item{
  width:50%;
   text-align: center;
}
</style>
<style lang="scss" scoped>
.articledel_content{
  padding:50px 0px 20px 0px;
}
.me_title{
    font-size:38px;
    color:#333;
    padding-top:5px;
    padding-bottom: 20px;
    letter-spacing: 1px;
  }
  .englisthtext{
    font-size:18px;
    color:#7F7F7F;
    margin-bottom: 20px;
  }
  .me_remarktext{
    color:#0295F9;
    font-size:20px;
    margin-bottom: 20px;
  }
.article_bombox{
    display: flex;
    justify-content: space-between;
    margin:20px 0px 50px 0px;
    .articlebom_li{
        width:31%;
        img{
          width:100%;
          margin-bottom: 18px;
        }
    }
}
.articledel_box{
    width:50%;
    margin-left:25%;
}
.article_list{
   width:100%;
   padding:20px;
   padding-top:0px;
   border-left:1px solid rgba(228, 228, 228, 1);
   border-right:1px solid rgba(228, 228, 228, 1);
   .articlelist_li{
     display: flex;
     color:#333;
     font-size:15px;
     margin-bottom:20px;
     .timebox{
       color:#999999;
       font-size:13px;
       line-height: 18px;
       display: flex;
       img{
         width:18px;
         height:18px;
         margin-right: 5px;
       }
     }
   }
}
.gonglue_box{
  width:80%;
  margin-left:10%;
  padding-top:20px;
  padding-bottom: 50px;
}
.article_box{
  .article_li{
     padding-top:10px;
     padding-bottom: 10px;
  }
}
  .me_title{
    font-size:38px;
    color:#333;
    padding-bottom: 20px;
    letter-spacing: 1px;
  }
  .englisthtext{
    font-size:18px;
    color:#7F7F7F;
    margin-bottom: 30px;
  }
  .me_remarktext{
    color:#0295F9;
    font-size:20px;
    margin-bottom: 20px;
  }
.product {
  width: 100%;
  height: 100%;
  background-color: #14679f;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

.p-video {
  width: 1000px;
  margin: 0 auto;
  padding: 60px 0;
}

//传统管理模式不足
.lacking {
  height: 420px;
  padding: 20px 0;
  //margin: 20px 0;

  .lacking-bottom {
    display: flex;
    justify-content: space-around;
    padding: 100px 100px;

    .lacking-bottom-item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      //justify-content: center;

      .lacking-bottom-item-img {
        width: 120px;
        height: 120px;
        background: #1667a0;
        border-radius: 50%;
        overflow: hidden;
        line-height: 160px;
      }
    }
    p {
      font-size: 16px;
      text-align: start;
      margin: 10px 0;
    }
  }
}

//平台目标
.target {
  margin-top: 50px;
  &-img {
    margin-top: 50px;
    text-align: center;
  }
}

//
.modular {
  margin-top: 50px;
  .modular-content {
    padding: 50px 50px;
    display: flex;
    justify-content: space-around;
  }
}
.modular-content-same {
  width: 182px;
  height: 405px;

  .same-item {
    height: 70px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .same-item-img {
      width: 70px;
      height: 70px;
      line-height: 100px;
      background: #1667a0;
      border-radius: 50%;
      text-align: center;
    }
    p {
      color: #1667a0;
      font-weight: 700;
      line-height: 70px;
    }
  }
}

.modular-content-center {
  width: 355px;
  height: 355px;
  img {
    width: 100%;
  }
}
//公共样式
.title,
.eTitle {
  font-size: 34px;
  font-weight: 400;
  color: #333;
  text-align: center;
}
.eTitle {
  font-size: 30px;
  padding: 10px 0;
}
</style>